import type { ChatEvent, ChatMessage, Filters, ListingDetail } from "../../shared/types";

/** POST a turn and yield the server's SSE frames as they arrive. */
export async function* streamChat(
  messages: ChatMessage[],
  filters: Filters,
  signal?: AbortSignal,
): AsyncGenerator<ChatEvent> {
  const res = await fetch("/api/chat", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ messages, filters }),
    signal,
  });

  if (!res.ok || !res.body) throw new Error(`Chat request failed (${res.status})`);

  const reader = res.body.pipeThrough(new TextDecoderStream()).getReader();
  let buffer = "";

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += value;

    let split: number;
    while ((split = buffer.indexOf("\n\n")) !== -1) {
      const frame = buffer.slice(0, split);
      buffer = buffer.slice(split + 2);
      for (const line of frame.split("\n")) {
        if (!line.startsWith("data:")) continue;
        try {
          yield JSON.parse(line.slice(5)) as ChatEvent;
        } catch {
          /* keepalive or partial frame */
        }
      }
    }
  }
}

export async function fetchListing(id: string): Promise<ListingDetail | null> {
  const res = await fetch(`/api/listings/${encodeURIComponent(id)}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`Listing request failed (${res.status})`);
  return (await res.json()) as ListingDetail;
}
